/*
 * @title App
 * @description Application entry point
 */

// Polyfills

// Misc

// Modules
import sidebar from 'Modules/sidebar/sidebar';
import filters from 'Modules/filters/filters';
import showPassword from './modules/showPassword';
import textareaResize from './modules/textareaResize';
import amountProduct from './modules/amountProduct';
import dropdown from './modules/dropdown';

// Components
import smoothScroll from 'Components/smooth-scroll';
import collapse from 'Components/collapse.js';

document.addEventListener('DOMContentLoaded', function() {
  // Modules
  sidebar();
  filters();
  showPassword();
  textareaResize();
  amountProduct();
  dropdown();
  
  // Components
  smoothScroll();
  collapse();
});
